import {mapActions, mapGetters} from "vuex";

import {LabTestsServices} from "@/services/lab-tests";
import {MedicineService} from "@/services/medicine";
import {
  GETTER_DOCTOR_PATIENT_PARTNER,
  ACTION_SET_FILE_ORDER_ID,
  ACTION_SET_MEDICINE_STATE,
} from "@/store/types";
import {generateGetLabTestCouponPayload} from "@/utils/lab-tests";
import Routes from "@/router/routes";

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      doctorPatientPartner: GETTER_DOCTOR_PATIENT_PARTNER,
    }),
  },
  methods: {
    ...mapActions({
      setLabRequestOrderId: ACTION_SET_FILE_ORDER_ID,
      setMedicineState: ACTION_SET_MEDICINE_STATE,
    }),
    async claimCoupon(patientToken, prescriptionUploadId) {
      if (this.loading) return;

      this.loading = true;
      this.$emit('loading', true)
      const {patient} = this.doctorPatientPartner[patientToken];

      try {
        const submitLabTestResponse = await LabTestsServices.submitLabTest(
          patientToken,
          generateGetLabTestCouponPayload(prescriptionUploadId, patient),
        );
        
        if (!submitLabTestResponse.data || submitLabTestResponse.data.result !== 1) {
          throw Error();
        }

        const getOrdersResponse = await MedicineService.getOrders();

        if (!getOrdersResponse.data || getOrdersResponse.data.result !== 1) {
          throw Error();
        }

        this.loading = false;
        this.$emit('root-chat-loading', true)
        this.setMedicineState({
          orders: getOrdersResponse.data.orders,
        });
        this.setLabRequestOrderId({uploadid: prescriptionUploadId, orderid: submitLabTestResponse.data.orderid});
        this.viewOrderDetails(patientToken, submitLabTestResponse.data.orderid);
      } catch (error) {
        this.loading = false;
        this.$emit('root-chat-loading', false);
        this.showToast({
          text: 'Failed to avail coupon. Please try again later.',
          theme: 'danger',
        });
      }
    },
    viewOrderDetails(patientToken, orderid) {
      this.$router.push({
        name: Routes.MEDICINE_ORDER_LAB_REQUESTS,
        params: {
          [Routes.MEDICINE_ORDER_ID_PARAM]: orderid,
          token: patientToken
        },
      });
    },
  },
}